import { Links } from '@/config/app'

export const useOpenDeployArticle = () => {
  return () => window.open(Links.deployToZendeskArticle, '_blank')
}
